import {MetaModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import {useRouter} from "next/router"
import React, {ReactNode, createContext, useEffect, useState} from "react"

interface MetaDataContextProps {
	metaData?: MetaModuleType
	changeMetaData: (data: MetaModuleType) => void
}

const metadata: MetaModuleType = {
	title: "One Communications",
	description:
		"One Communications is a Finnish and European online video software company.",
	keywords: "keyword1, keyword2, keyword3",
	author: "One Communications",
	ogTitle: "One Communications",
	ogType: "WebPage",
	ogDescription:
		"One Communications is a Finnish and European online video software company.",
	ogImage: "/DB-2.jpg",
}

export const MetaDataContext = createContext<MetaDataContextProps>({
	metaData: metadata,
	changeMetaData: () => {},
})

interface MetaDataProviderProps {
	children: ReactNode
}

export const MetaDataProvide = ({children}: MetaDataProviderProps) => {
	const [metaData, setMetaData] = useState<MetaModuleType>(metadata)
	const router = useRouter()

	const changeMetaData = (data: MetaModuleType) => {
		setMetaData(data)
	}

	useEffect(() => {
		return () => {
			setMetaData(metadata)
		}
	}, [router.pathname])

	return (
		<MetaDataContext.Provider value={{metaData, changeMetaData}}>
			{children}
		</MetaDataContext.Provider>
	)
}
